import { WasteEntryDto, CreateWasteEntryDto, ChangeWasteEntryContainerDto } from '@services/dtos'
import { baseCrudReducer } from './baseCrudReducer'
import { wasteEntryService, WasteEntriesFilters } from '@services/wasteEntryService'
import { createAsyncThunk } from '@reduxjs/toolkit'
import { getWasteContainers } from './wasteContainerReducer'

const { reducer, actions, thunks } = baseCrudReducer<
  WasteEntryDto,
  CreateWasteEntryDto,
  never,
  WasteEntriesFilters
>('wasteEntry', wasteEntryService)

export default reducer

export const { setFilters: setWasteEntryFilters } = actions

export const {
  getAll: getWasteEntries,
  create: createWasteEntry,
} = thunks

export const cancelWasteEntry = createAsyncThunk<void, string>(
  'wasteEntry/cancel',
  async (id, { dispatch }) => {
    await wasteEntryService.cancel(id)
    dispatch(thunks.getAll())
    dispatch(getWasteContainers())
  },
)

export const changeWasteEntryContainer = createAsyncThunk<
  void,
  { id: string; dto: ChangeWasteEntryContainerDto }
>(
  'wasteEntry/changeContainer',
  async ({ id, dto }, { dispatch }) => {
    await wasteEntryService.changeContainer(id, dto)
    dispatch(thunks.getAll())
    dispatch(getWasteContainers())
  },
)
